module.exports = __webpack_public_path__ + "img/change-gb-whatsapp-home-screen.4a835b39.webp";